import React, { Component } from 'react'
import { Form, Select, InputNumber, Row, Col } from 'antd'
import { AgeProvider, AgeConsumer } from '../../../../context/AgeContext'
import { SpecieProvider, SpecieConsumer } from '../../../../context/SpecieContext'

export default class MappingAgeRangeForm extends Component {
  render() {
    return (
      <SpecieProvider>
        <AgeProvider>
          <SpecieConsumer>
            {({ fetching: fetchingSpecies, species, requestSpecieList }) => (
              <AgeConsumer>
                {({ fetching: fetchingAges, ages, requestAgeList }) => {
                  if (!fetchingAges && !ages) {
                    setTimeout(() => {
                      requestAgeList({
                        options: {
                          limit: 9999
                        }
                      })
                    }, 50)
                  }

                  if (!fetchingSpecies && !species) {
                    setTimeout(() => {
                      requestSpecieList({
                        options: {
                          limit: 9999
                        }
                      })
                    }, 50)
                  }
    
                  const agesOptions = ages?.map(age => {
                    return {
                      label: age.name,
                      value: age.key
                    }
                  }) as any

                  const speciesOptions = species?.map(specie => {
                    return {
                      label: specie.name,
                      value: specie.uuid
                    }
                  }) as any
    
                  return (
                    <>
                      <Form.Item
                        label="Age"
                        name="age_key"
                        rules={[
                          {
                            required: true,
                            message: 'Missing an age'
                          }
                        ]}
                      >
                        <Select
                          loading={fetchingAges}
                          placeholder="Select an age"
                          options={agesOptions}
                        />
                      </Form.Item>

                      <Form.Item
                        label="Species"
                        name="specie_uuid"
                        rules={[
                          {
                            required: true,
                            message: 'Missing a species'
                          }
                        ]}
                      >
                        <Select
                          loading={fetchingSpecies}
                          placeholder="Select a species"
                          options={speciesOptions}
                        />
                      </Form.Item>

                      <Row gutter={12}>
                        <Col xs={12}>
                          <Form.Item
                            label="Minimum"
                            name="min"
                            rules={[
                              {
                                required: true,
                                message: 'Missing an minimum'
                              }
                            ]}
                          >
                            <InputNumber min={0} />
                          </Form.Item>
                        </Col>

                        <Col xs={12}>
                          <Form.Item
                            label="Maximum"
                            name="max"
                            rules={[
                              {
                                required: true,
                                message: 'Missing an maximum'
                              }
                            ]}
                          >
                            <InputNumber min={0} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  )
                }}
              </AgeConsumer>
            )}
          </SpecieConsumer>
        </AgeProvider>
      </SpecieProvider>
    )
  }
}
